module.exports = __webpack_public_path__ + "static/img/browser_ie.811e75c3.png";